// extracted by mini-css-extract-plugin
export default {"loading":"PropSearchBreadcrumb_loading__KG7Tg","separator":"PropSearchBreadcrumb_separator__8YjM1","bcLabel":"PropSearchBreadcrumb_bcLabel__QQipV"};